export const UPDATE_TENANT_SETTINGS = "UPDATE_TENANT_SETTINGS";
export const UPDATE_TENANT_SETTINGS_SUCCESS = "UPDATE_TENANT_SETTINGS_SUCCESS";
export const UPDATE_TENANT_SETTINGS_ERROR = "UPDATE_TENANT_SETTINGS_ERROR";
export const RESET_TENANT_SETTINGS_STATUS = "RESET_TENANT_SETTINGS_STATUS";
export const RESET_TENANT_SETTINGS_ERROR = "RESET_TENANT_SETTINGS_ERROR";
export const GET_TENANT_SETTINGS = "GET_TENANT_SETTINGS";
export const GET_TENANT_SETTINGS_SUCCESS = "GET_TENANT_SETTINGS_SUCCESS";
export const GET_TENANT_SETTINGS_ERROR = "GET_TENANT_SETTINGS_ERROR";
